export const THIRD_PARTY_AUTHENTICATION_ENDPOINT = '/auth/third-party/google'
